// extracted by mini-css-extract-plugin
export var button = "_69-4";
export var hasDarkBackground = "_69-7";
export var hasLightBackground = "_69-6";
export var iconWrapper = "_69-0";
export var large = "_69-2";
export var medium = "_69-1";
export var small = "_69-5";
export var xsmall = "_69-3";